var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('base-heading',{attrs:{"id":"api"}},[_vm._v(_vm._s(_vm.computedHeading))]),_c('base-markdown',[_vm._v("Generic.Pages.apiText")]),_c('doc-api-items',{attrs:{"lang":_vm.lang,"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }